// extracted by mini-css-extract-plugin
export default {"contact":"Contact_contact__Ma-0s","content":"Contact_content__Yk1XJ","title":"Contact_title__evB1T","infoBox":"Contact_infoBox__I0jVv"};